import InformationIcon from "shared/ui/icons/Information";
import { QuantitySelector } from "./QuantitySelector";
import { getFormattedPrice } from "shared/utils/getFormattedPrice";
import { REACT_APP_GERS_API_URL } from "shared/config";
import { CategoryStandardProduct } from "shared/api/middleware-api-client";

const productDetails = {
  title: "Schoonmaakset",
  description: "Hou de deur zo goed als nieuw",
  price: "€ 9,99",
  imageUrl:
    "https://cdn.builder.io/api/v1/image/assets/TEMP/b9e7446aed8f6ef5d9dc7a17083b25634829f96724a915fbadf895dc7bd6165a?apiKey=6ffc457e32004e0f85e3f4c96c124f86&",
};

interface ProductCardProps {
  product: CategoryStandardProduct;
  additionalDesc?: boolean;
}
export const ProductCard: React.FC<ProductCardProps> = ({ product }) => {
  const formattedPrice = getFormattedPrice(product.price);
  const imageUrl = product.imageId
    ? `${REACT_APP_GERS_API_URL}/StandardProducts/download-file/${product.imageId}`
    : productDetails.imageUrl;

  return (
    <section className="gg-relative gg-flex gg-flex-col max-md:gg-ml-0 max-md:gg-w-full">
      <header className="gg-flex gg-w-full gg-text-dark-blue">
        <div className="gg-h-min-fit gg-flex gg-w-full">
          <img
            src={imageUrl}
            alt={product.name}
            className="gg-aspect-square gg-w-[5.6rem] gg-max-w-full gg-shrink-0 gg-bg-gray-50 gg-object-cover gg-object-center gg-mix-blend-multiply sm:gg-w-28"
          />
          <div className="gg-flex gg-flex-col gg-px-3 gg-py-3 sm:gg-px-3.5">
            <div className="gg-flex gg-flex-col">
              <div className="gg-flex gg-items-center">
                <span className="gg-max-w-[215px] gg-truncate gg-pr-1 gg-text-sm gg-font-extrabold sm:gg-max-w-[350px] sm:gg-pr-1.5 sm:gg-text-base sm:gg-tracking-wide md:gg-max-w-[400px] lg:gg-max-w-[285px]">
                  {product.name}
                </span>
                {/* <InformationIcon className="gg-cursor-pointer hover:gg-fill-slate-500 gg-fill-dark-blue" /> */}
                <div className="gg-w-min-fit gg-group">
                  <InformationIcon className="gg-cursor-pointer gg-fill-dark-blue hover:gg-fill-slate-500" />

                  {/* {showAddDescription && ( */}
                  <section className="gg-absolute gg-inset-x-0 gg-top-28 gg-z-10 gg-hidden gg-min-w-fit gg-items-center gg-gap-x-3 gg-bg-dark-blue gg-px-4 gg-pb-4 gg-pt-1 gg-text-zinc-200 gg-transition-opacity gg-duration-300 gg-ease-in-out group-hover:gg-block">
                    <h5 className="gg-text-sm">{product.name}</h5>
                    <p className="gg-text-xs">{product.description}</p>
                  </section>
                </div>
              </div>

              <span className="gg-w-full gg-max-w-[15rem] gg-truncate gg-text-xs gg-font-light gg-text-gray-500 sm:gg-max-w-xs sm:gg-text-sm">
                {product.description}
              </span>
            </div>
            <div className="gg-mt-3.5 gg-text-base gg-font-bold gg-leading-6">
              {formattedPrice}
            </div>
          </div>
        </div>

        <div className="gg-absolute gg-bottom-2 gg-right-0">
          <QuantitySelector product={product} />
        </div>
      </header>

      {/* {additionalDesc && (
				<section className="gg-flex gg-gap-3 gg-py-4 gg-px-4 gg-text-sm gg-leading-5 gg-bg-dark-blue gg-text-zinc-200 max-md:gg-flex-wrap">
					<div>
						<InformationIcon />
					</div>
					<div>
						Voor een perfecte dekking mocht de deur beschadigen adviseren
						wij dit product <span className="gg-font-bold">1 keer</span>{" "}
						toe te voegen aan uw bestelling.
					</div>
				</section>
			)} */}
    </section>
  );
};
